module.exports = __webpack_public_path__ + "static/media/10.f54f9ee3.png";